import React, { useState } from "react";
import ParagraphTag from "../../reusebale/Paragraph";
import ImageTag from "../../reusebale/imageTag";
import moment from "moment";
import NoData from "../../reusebale/noData"
import Myloader from "../../reusebale/myLoader"
import {
  ArrowUpDown,
  ArrowDownUp,
  SquareCheck,
  SquareX,
  CircleHelp,
  Hourglass,
} from "lucide-react";
import db from "../../../db/index.json";

const LeaseTable = ({allLeases, onViewDetails}) => {
  const { lease } = db;

  const [data, setData] = useState([]);

  // State for sorting
  const [sortConfig, setSortConfig] = useState({
    key: "lease",
    direction: "asc",
  });

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });
    setData(sortedData);
  };

  function CalculateDaysBetween(date1, date2) {
    // Parse the dates using Moment.js
    const startDate = moment(date1);
    const endDate = moment(date2);

    // Calculate the difference in days
    const daysDifference = endDate.diff(startDate, "days");

    return daysDifference;
  }

  function CalculateTotalRent(item) {
    if (!item) {
      return 0;
    }

    // Get base rent from unitInfo
    const baseRent = Number(item?.unitInfo?.rent) || 0;

    // Calculate additional charges
    const additionalChargesTotal = Array.isArray(item?.additionalCharges)
      ? item.additionalCharges.reduce((sum, charge) => {
          return sum + (Number(charge?.amount) || 0);
        }, 0)
      : 0;

    // Total rent = base rent + additional charges
    return baseRent + additionalChargesTotal;
  }

  return (
    <div className="h-full pt-5">
      <div className="bg-white w-full h-[87%]">
        <div className="w-[95%] mx-auto h-full py-4">
          <div className="flex items-center h-[12%]">
            <ParagraphTag
              content={lease.leaseth1}
              classes="text-darkColor font-popinsSemiBold text-base"
            />
          </div>
          <div className="overflow-x-auto h-[300px] panelScroll w-full pt-4">
            <table className="w-full ">
              <thead className="sticky top-0 bg-white">
              <tr className="border-b border-black/20">
                  <th className="w-[20%] text-left pb-2">
                    <span className="flex">
                      <ParagraphTag
                        content={lease.heading}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {/* {sortConfig.key === "lease" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("lease")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("lease")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("property")}
                        />
                      )} */}
                    </span>
                  </th>
                  <th className="w-[8%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={lease.units}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {/* {sortConfig.key === "units" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("units")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("units")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("units")}
                        />
                      )} */}
                    </span>
                  </th>
                  <th className="w-[8%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={lease.status}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {/* {sortConfig.key === "status" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("status")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("status")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("status")}
                        />
                      )} */}
                    </span>
                  </th>

                  <th className="w-[20%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={lease.duration}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                      />
                      {/* {sortConfig.key === "duration" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("duration")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("duration")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("duration")}
                        />
                      )} */}
                    </span>
                  </th>

                  <th className="w-[8%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={lease.rent}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {/* {sortConfig.key === "rent" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("rent")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("rent")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("rent")}
                        />
                      )} */}
                    </span>
                  </th>
                  <th className="w-[8%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={lease.deposit}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {/* {sortConfig.key === "deposit" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("deposit")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("deposit")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("deposit")}
                        />
                      )} */}
                    </span>
                  </th>

                  <th className="w-[28%] text pr-4 pb-2">
                    <ParagraphTag
                      content={lease.actions}
                      classes="text-darkColor/40 font-popinsSemiBold text-xs"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
              {allLeases.map((item) => (
                  <tr
                    key={item.id}
                    className="hover:bg-gray-100 rounded-md cursor-pointer"
                  >
                    <td className="py-2">
                      <div className="flex items-center justify-between">
                        <div className="w-[18%] rounded-full">
                          <ImageTag
                            path="/assets/daashboard/balance.png"
                            classes="w-full"
                            altText="logo"
                          />
                        </div>

                        <div
                          className="w-[78%] cursor-pointer"
                          onClick={() => {
                            onViewDetails(item.status, item._id);
                          }}
                        >
                          <ParagraphTag
                            content={item.ID}
                            classes="text-darkColor/50 font-popinsMedium text-xs"
                          />
                          <ParagraphTag
                            content={item?.propertyInfo?.propertyName}
                            classes="text-darkColor font-popinsSemiBold text-sm"
                          />
                        </div>
                      </div>
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      {item?.unitInfo?.unitName}
                    </td>
                    <td className="py-2 font-popinsMedium text-darkColor text-sm">
                      <span className="flex justify-center">
                        {(() => {
                          switch (item.status) {
                            case "active":
                              return <SquareCheck color="#01CB78" size={20} />;
                            case "pendingPayment":
                              return <Hourglass color="#F59E0B" size={20} />;
                            case "notapprove":
                              return <CircleHelp color="#B3B3B3" size={20} />;
                            default:
                              return <SquareX color="#E43B3B" size={20} />;
                          }
                        })()}
                      </span>
                    </td>

                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-xs text-center">
                      <div className="flex flex-col">
                        <span>{`${moment(item?.startDate).format(
                          "MM/DD/YYYY"
                        )} - ${moment(item?.endDate).format(
                          "MM/DD/YYYY"
                        )}`}</span>
                        <span className="text-darkColor/50">{`${CalculateDaysBetween(
                          item?.startDate,
                          item?.endDate
                        )} Days left`}</span>
                      </div>
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      {`$ ${Number(CalculateTotalRent(item)).toFixed(2)}`}
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      {`$ ${
                        item?.securityDepositAmount
                          ? item?.securityDepositAmount
                          : 0
                      }`}
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm">
                      <div className="flex justify-end">
                        <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                          {`${item?.tenantInfo.firstName} ${item?.tenantInfo.lastName}`}
                        </td>
                        <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                          {`${item?.tenantInfo.cellNo} `}
                        </td>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {(allLeases.length === 0) && (
              <div className="w-full mt-5">
                <NoData />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaseTable;
